import { useSelector, useDispatch } from 'react-redux';
import { Badge, IconButton, Tooltip } from '@mui/material';
import Icon from 'app/main/components/Icon';

import { useSettings } from 'app/main/components';
import withReducer from 'app/store/withReducer';
import { selectNotifications } from 'app/store/notifications/notificationsSlice';
import reducer from './store';
import { toggleNotificationPanel } from './store/stateSlice';

interface NotificationPanelToggleButtonProps {
	children: React.ReactNode;
}

function NotificationPanelToggleButton({
	children = <Icon icon="bell-outline" />
}: NotificationPanelToggleButtonProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const notifications = useSelector(selectNotifications);
	const notificationCounter = notifications.filter(notification => !notification.isRead).length;

	return (
		<Tooltip title={t('NOTIFICATIONS_BUTTON')} arrow>
			<IconButton color="inherit" className="h-40 w-40" onClick={ev => dispatch(toggleNotificationPanel())}>
				<Badge badgeContent={notificationCounter} color="secondary" overlap="circular" max={99}>
					{children}
				</Badge>
			</IconButton>
		</Tooltip>
	);
}

export default withReducer('notificationPanel', reducer)(NotificationPanelToggleButton);
